import { FC } from 'react'

import { Flex, IconButton, Text, Tooltip } from '@chakra-ui/react'

interface Props {
    icon: JSX.Element
    hoveredIcon?: JSX.Element
    label: string
    active: boolean
    sidebarClosed: boolean
    onClick: () => void
    count?: number
}

export const NavItem: FC<Props> = ({
    icon,
    hoveredIcon,
    label,
    active,
    sidebarClosed,
    onClick,
    count,
}): JSX.Element => {
    return (
        <Tooltip
            hasArrow
            isDisabled={!sidebarClosed}
            label={count !== undefined && count > 0 ? `${label} (${count})` : label}
            placement={'right'}
            padding={'10px'}
            borderRadius={'8px'}
        >
            <Flex
                tabIndex={0}
                bg={active ? '#DEE6FB' : 'transparent'}
                alignItems={'center'}
                gap={'14px'}
                _hover={{ color: active ? '#163690' : '#4B4B4E', background: active ? '#D3DEFC' : '#F5F5F5' }}
                _focus={{
                    boxShadow: '0px 0px 0px 2px rgba(36, 90, 240, .4)',
                    bg: active ? '#E9EFFE' : '#FFF',
                    outline: 'none',
                }}
                color={'#4B4B4E'}
                cursor={'pointer'}
                borderRadius={'8px'}
                py={'10px'}
                px={'10px'}
                pos={'relative'}
                onClick={onClick}
                outline={'none'}
            >
                {active ? (
                    <IconButton
                        color={active ? '#0E4EF2' : 'inherit'}
                        icon={hoveredIcon}
                        aria-label={label}
                        w={'20px'}
                        h={'20px'}
                        minW={'20px'}
                        background={'none'}
                        _hover={{ background: 'none' }}
                        tabIndex={-1}
                    />
                ) : (
                    <IconButton
                        color={active ? '#0E4EF2' : 'inherit'}
                        icon={icon}
                        aria-label={label}
                        w={'20px'}
                        h={'20px'}
                        minW={'20px'}
                        background={'none'}
                        _hover={{ background: 'none' }}
                        tabIndex={-1}
                    />
                )}

                <Text
                    fontSize={'sm'}
                    fontWeight={'medium'}
                    color={active ? '#0E4EF2' : 'inherit'}
                    textOverflow={'ellipsis'}
                    maxW={'150px'}
                    overflow={'hidden'}
                    whiteSpace={'nowrap'}
                >
                    {label}
                </Text>
                {count !== undefined && count > 0 && !sidebarClosed && (
                    <Flex
                        ml={'auto'}
                        minW={'20px'}
                        h={'20px'}
                        px={'6px'}
                        alignItems={'center'}
                        justifyContent={'center'}
                        borderRadius={'4px'}
                        bg={active ? '#245af0' : '#eaeaeb'}
                        color={active ? '#FFFFFF' : '#000000'}
                        fontSize={'xs'}
                        fontWeight={'semibold'}
                    >
                        {count > 99 ? '99+' : count}
                    </Flex>
                )}
                {count !== undefined && count > 0 && sidebarClosed && (
                    <Flex
                        pos={'absolute'}
                        top={'3px'}
                        right={'3px'}
                        w={'10px'}
                        h={'10px'}
                        borderRadius={'full'}
                        bg={'#E53E3E'}
                        border={'2px solid #FFFFFF'}
                    />
                )}
            </Flex>
        </Tooltip>
    )
}
